
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-streaming-demo-typing","docs-x-markdown-streaming-demo-format","docs-x-markdown-streaming-demo-animation"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.zh-CN.md?type=demo')
};